module.exports = __webpack_public_path__ + "static/media/exalumnos.a6bcdd87.svg";